import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { mockSearch, setMockHandler } from './api/client'
import { router } from './router'
import './style.css'

async function boot() {
  // ?mock=1 (or VITE_MOCK=1): answer from fixtures so every screen is clickable without a backend.
  const mock = mockSearch()
  if (mock !== null) {
    const { createMock, mockOptionsFromUrl } = await import('./api/fixtures/mock')
    setMockHandler(createMock(mockOptionsFromUrl(mock)).handler)
  }
  createApp(App).use(createPinia()).use(router).mount('#app')
}
void boot()
